
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class PaymentRequestReaderService {

   public static getSpaPaymentRequests(
           axiosInstance: AxiosInstance, input: ServerData.PaymentRequestWebReader.GetSpaPaymentRequests$Input,
           f: (output: ServerData.SpineData$PaymentRequestDetailsWithEntries[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'paymentapi/paymentrequest/get-spa-payment-requests',
            {params : input.toJson()}
        ).then((response) => (response.data as object[]).map((x) => ServerData.SpineData$PaymentRequestDetailsWithEntries.fromJson(x)))
       .then((output) => f(output))
       .catch(theEh);
   }


}

